import React from 'react';
import { LFC } from '../../Legacy';
import { useResolve } from '../Container';
import { WorkspaceModel } from '../dashboard/Models';
import { FolderView } from './FolderView';
import { WorkspaceRootView } from './WorkspaceRootView';

export type WorkspaceSwitchProps = { entityId: string, param: string };
export const WorkspaceSwitch: LFC<WorkspaceSwitchProps> = ({ entityId, param }) => {
    param = param?.toLowerCase();

    const model = useResolve(WorkspaceModel);
    const folderId = entityId === model.id ? null : entityId;

    if (entityId === model.id) return <WorkspaceRootView key={model.id} />;
    if (entityId.startsWith('FO')) return <FolderView key={folderId} folderId={folderId} />;

    return null;
};
